import React, { ReactNode, ReactNodeArray } from "react";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import cn from "classnames";

import { TestProps } from "@mapmycustomers/ui";

import CardTitle, { CardTitleProps } from "@app/component/DashCard/CardTitle";
import styles from "@app/component/DashCard/DashCard.module.scss";

interface Props extends CardTitleProps, TestProps {
  actions?: ReactNode | ReactNodeArray;
  centerAlignContent?: boolean;
  children: ReactNode;
  className?: string;
  info?: ReactNode;
  subActions?: ReactNode | ReactNodeArray;
  title: string;
  titleFaIcon?: IconProp;
  titleIcon?: ReactNode;
}

const DashCard: React.FC<Props> = (props) => {
  const {
    actions,
    centerAlignContent = false,
    children,
    className,
    cypressId,
    info,
    subActions,
    title,
    titleFaIcon,
    titleIcon,
  } = props;
  return (
    <section className={cn(styles.container, className)} data-cy={cypressId}>
      <div className={styles.content}>
        <div className={styles.header}>
          <CardTitle info={info} title={title} titleFaIcon={titleFaIcon} titleIcon={titleIcon} />
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
        {subActions && (
          <div className={styles.header}>
            <div className={styles.subActions}>{subActions}</div>
          </div>
        )}
        <div className={cn(styles.body, { [styles.bodyCentered]: centerAlignContent })}>
          {children}
        </div>
      </div>
    </section>
  );
};

export default DashCard;
